const UserNameType = Symbol();

// ユーザー名の最大長
export const UserNameMaxLength = 60;

export class UserName {
    [UserNameType]: any;
    readonly value: string;

    private constructor(name: string) {
        this.value = name;
    }

    static fromString(name: string): UserName {
        return new UserName(name);
    }

    static fromNothing(): UserName {
        return new UserName("");
    }

    // ユーザー名の最大長チェック
    isValidLength(): boolean {
        return !(this.value.length > UserNameMaxLength);
    }
}
